import { j as k } from "./jsx-runtime-3tyXYecC.mjs";
import { forwardRef as S } from "react";
import { f as n } from "./index-LyFokDcn.mjs";
import { m as v } from "./tss-DN0acMKN.mjs";
import { g as l } from "./get-encore-value-Di648HqV.mjs";
import { B as h } from "./Box-B5hjovXR.mjs";
import { f as F } from "./format-base-props-8NDUNDcL.mjs";
const W = v()((i, d) => {
  const {
    borderRadiuses: u,
    constructs: { border: r, surface: e },
    mixins: s,
    palette: a
  } = i, { backgroundColor: m, borderColor: c, borderRadius: g, borderStyle: t, boxShadow: x, objectFit: w, v2: o } = d, f = {
    "primary-weak": e.primary.weak,
    "primary-medium": e.primary.medium,
    "primary-strong": e.primary.strong,
    "success-weak": e.success.weak,
    "success-medium": e.success.medium,
    "success-strong": e.success.strong,
    "warning-weak": e.warning.weak,
    "warning-medium": e.warning.medium,
    "warning-strong": e.warning.strong,
    "error-weak": e.error.weak,
    "error-medium": e.error.medium,
    "error-strong": e.error.strong,
    "info-weak": e.info.weak,
    "info-medium": e.info.medium,
    "info-strong": e.info.strong,
    "discovery-weak": e.discovery.weak,
    "discovery-medium": e.discovery.medium,
    "discovery-strong": e.discovery.strong,
    "notice-strong": e.notice.strong
  }, y = {
    none: "transparent",
    ...n.ifFeature(
      "encore",
      {
        ...f,
        "neutral-extra-extra-weak": e.neutral.xxWeak,
        "neutral-extra-weak": e.neutral.xWeak,
        ...o ? {
          "neutral-weak": e.neutral.weak,
          "neutral-medium": e.neutral.medium,
          "neutral-strong": e.neutral.strong,
          "neutral-extra-strong": e.neutral.xStrong
        } : {
          "neutral-weak": e.neutral.forcedWhite,
          "neutral-medium": e.neutral.xxWeak,
          "neutral-strong": e.neutral.xxWeak,
          "neutral-extra-strong": e.neutral.xxWeak
        },
        "neutral-extra-extra-strong": e.neutral.xxStrong,
        "neutral-inverted": e.neutral.inverted,
        "neutral-forced-white": e.neutral.forcedWhite
      },
      {
        "neutral-extra-extra-weak": a.gray[50],
        "neutral-extra-weak": a.gray[100],
        ...o ? {
          "neutral-weak": a.gray[200],
          "neutral-medium": a.gray[200],
          "neutral-strong": a.gray[600],
          "neutral-extra-strong": a.gray[800]
        } : {
          "neutral-weak": a.background.default,
          "neutral-medium": a.gray[100],
          "neutral-strong": a.gray[200],
          "neutral-extra-strong": a.gray[300]
        },
        "neutral-extra-extra-strong": a.gray[900],
        "neutral-inverted": a.common.black,
        "neutral-forced-white": a.common.white
      }
    )
  }, p = {
    "primary-weak": r.primary.weak,
    "primary-medium": r.primary.medium,
    "primary-strong": r.primary.strong,
    "success-weak": r.success.weak,
    "success-medium": r.success.medium,
    "success-strong": r.success.strong,
    "warning-weak": r.warning.weak,
    "warning-medium": r.warning.medium,
    "warning-strong": r.warning.strong,
    "error-weak": r.error.weak,
    "error-medium": r.error.medium,
    "error-strong": r.error.strong,
    "info-weak": r.info.weak,
    "info-medium": r.info.medium,
    "info-strong": r.info.strong,
    "discovery-weak": r.discovery.weak,
    "discovery-medium": r.discovery.medium,
    "discovery-strong": r.discovery.strong
  }, b = {
    none: "transparent",
    ...n.ifFeature(
      "encore",
      {
        ...p,
        "neutral-extra-extra-weak": r.neutral.xxWeak,
        "neutral-extra-weak": r.neutral.xWeak,
        ...o ? {
          "neutral-weak": r.neutral.weak,
          "neutral-medium": r.neutral.medium,
          "neutral-strong": r.neutral.strong,
          "neutral-extra-strong": r.neutral.xStrong
        } : {
          "neutral-weak": r.neutral.xWeak,
          "neutral-medium": r.neutral.medium,
          "neutral-strong": r.neutral.medium,
          "neutral-extra-strong": r.neutral.medium
        },
        "neutral-inverted": r.neutral.inverted,
        "neutral-forced-white": r.neutral.forcedWhite
      },
      {
        "neutral-extra-extra-weak": a.gray[100],
        "neutral-extra-weak": a.gray[200],
        ...o ? {
          "neutral-weak": a.gray[300],
          "neutral-medium": a.gray[400],
          "neutral-strong": a.gray[500],
          "neutral-extra-strong": a.gray[700]
        } : {
          "neutral-weak": a.gray[200],
          "neutral-medium": a.gray[300],
          "neutral-strong": a.gray[400],
          "neutral-extra-strong": a.gray[500]
        },
        "neutral-inverted": a.common.black,
        "neutral-forced-white": a.common.white
      }
    )
  };
  return {
    root: {
      backgroundColor: l(m, y),
      borderColor: l(c, b),
      borderRadius: l(g, {
        none: "unset",
        small: n.ifFeature("encore", u[200], 2),
        medium: n.ifFeature("encore", u[300], 8),
        large: n.ifFeature("encore", u[400], 16),
        full: n.ifFeature("encore", u[1e3], 0)
      }),
      boxShadow: l(x, {
        none: "unset",
        small: n.ifFeature("encore", s.boxShadow("300", e.neutral.xxStrong), "0px 1px 0px 0px rgba(0, 0, 0, 0.05)"),
        medium: n.ifFeature("encore", s.boxShadow("300", e.neutral.xxStrong), "0px 1px 4px 0px rgba(0, 0, 0, 0.15)"),
        large: n.ifFeature("encore", s.boxShadow("500", e.neutral.xxStrong), "0px 2px 6px 0px rgba(0, 0, 0, 0.05)"),
        "extra-large": n.ifFeature(
          "encore",
          s.boxShadow("500", e.neutral.xxStrong),
          "0px 8px 14px 3px rgba(0, 0, 0, 0.05)"
        )
      }),
      borderStyle: n.ifFeature("encore", t === "dashed" ? "none" : t, t),
      borderWidth: 1,
      objectFit: w
    }
  };
}), O = S((i, d) => {
  const {
    backgroundColor: u = n.ifFeature("encore", "none"),
    borderColor: r = n.ifFeature("encore", "none"),
    borderRadius: e = n.ifFeature("encore", "none"),
    borderStyle: s = n.ifFeature("encore", "none"),
    boxShadow: a = n.ifFeature("encore", "none"),
    encoreOnly: m,
    objectFit: c = "fill",
    v2: g = !1,
    ...t
  } = i, { classes: x } = W({
    backgroundColor: u,
    borderColor: r,
    borderRadius: e,
    borderStyle: s,
    boxShadow: a,
    encoreOnly: m,
    objectFit: c,
    v2: g,
    ...t
  }), w = [t["data-fabric-component"], "StyledBox"].filter(Boolean).join(" "), o = /* @__PURE__ */ k.jsx(h, { ...F(t), className: x.root, "data-fabric-component": w, ref: d });
  return m ? n.ifFeature("encore", o, /* @__PURE__ */ k.jsx("div", { children: i.children })) : o;
});
export {
  O as S
};
//# sourceMappingURL=styled-box-DJEn6F3U.mjs.map
